module.exports = __webpack_public_path__ + "static/media/kc6.37589259.png";